"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopularBrandsTitle = exports.PopularBrandsSegment = exports.PopularBrandsRoot = exports.PopularBrandsListElement = exports.PopularBrandsIconWrapper = exports.PopularBrandsAllBrands = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const PopularBrandsRoot = exports.PopularBrandsRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  listStyle: 'none',
  marginTop: theme.spacing(2),
  '&:last-child': {
    marginBottom: theme.spacing(2)
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    margin: theme.spacing(0, 3, 2, 0),
    order: 1,
    padding: 0,
    width: '100%',
    '&:last-child': {
      marginBottom: 'unset'
    }
  }
}));
const PopularBrandsListElement = exports.PopularBrandsListElement = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme
}) => ({
  display: 'flex',
  paddingLeft: theme.spacing(10),
  textAlign: 'left',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(2),
    paddingLeft: 0
  }
}));
const PopularBrandsTitle = exports.PopularBrandsTitle = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'inline-block',
  flexGrow: 1,
  fontSize: theme.typography.h6.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: '2.1rem',
  maxWidth: 235,
  height: 30,
  paddingLeft: 0,
  textDecoration: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'unset',
    maxWidth: 'unset',
    fontSize: '1.6rem',
    '&:hover, &:focus, &:active': {
      color: theme.palette.grey[600],
      WebkitTapHighlightColor: 'transparent'
    }
  }
}));
const PopularBrandsIconWrapper = exports.PopularBrandsIconWrapper = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isSubcategoryActive,
  theme
}) => ({
  fontSize: theme.typography.h6.fontSize,
  lineHeight: '2.2rem',
  marginRight: 18,
  transition: '0.1s ease-in',
  ...(isSubcategoryActive && {
    transform: 'rotate(180deg)'
  })
}));
const PopularBrandsSegment = exports.PopularBrandsSegment = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'block',
  fontSize: '1.6rem',
  fontWeight: theme.typography.fontWeightLight,
  lineHeight: '2.1rem',
  overflow: 'hidden',
  padding: theme.spacing(0, 0, 3, 14),
  textDecoration: 'none',
  textOverflow: 'ellipsis',
  WebkitTapHighlightColor: 'transparent',
  '&:first-of-type': {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(3)
  },
  '&:last-of-type': {
    paddingBottom: theme.spacing(2)
  },
  '&:hover, &:focus': {
    color: theme.palette.grey[600]
  },
  '&:active': {
    fontWeight: theme.typography.fontWeightBold
  },
  [theme.breakpoints.up('md')]: {
    padding: 0,
    '&:first-of-type': {
      marginTop: 'unset',
      paddingTop: 'unset'
    },
    '&:hover, &:focus, &:active': {
      color: theme.palette.text.disabled,
      WebkitTapHighlightColor: 'transparent'
    },
    '&:active': {
      fontWeight: 'unset'
    }
  }
}));
const PopularBrandsAllBrands = exports.PopularBrandsAllBrands = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.body1.fontSize,
    overflow: 'hidden',
    textDecoration: 'underline',
    textOverflow: 'ellipsis',
    '&:hover, &:focus, &:active': {
      color: theme.palette.text.disabled,
      WebkitTapHighlightColor: 'transparent'
    }
  }
}));
